import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import OurClients from './pages/OurClients';
import Career from './pages/Career';
import Contact from './pages/Contact';
import Internship from './pages/Internship';
import WebApplication from './pages/WebApplication';
import MobileApplication from './pages/MobileApplication';
import DigitalMarketing from './pages/DigitalMarketing';
import Devops from './pages/Devops';
import SoftwareTraining from './pages/SoftwareTraining';
import SoftwareConsulting from './pages/SoftwareConsulting';
import { loadVendorScriptsOnce, reinitOnRouteChange } from './lib/loadVendorScripts';
import PageTransition from './components/PageTransition';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    loadVendorScriptsOnce().then(() => {
      if (!cancelled) {
        reinitOnRouteChange();
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    reinitOnRouteChange();
  }, [location.pathname]);

  return (
    <>
      <PageTransition />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/our-clients" element={<OurClients />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/internship" element={<Internship />} />
        <Route path="/web-application" element={<WebApplication />} />
        <Route path="/mobile-application" element={<MobileApplication />} />
        <Route path="/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/devops" element={<Devops />} />
        <Route path="/software-training" element={<SoftwareTraining />} />
        <Route path="/software-consulting" element={<SoftwareConsulting />} />
      </Routes>
    </>
  );
}

